import Vue from 'vue';
import Errors from '../../classes/Errors';

Vue.component('forgot-password', {

    data() {
        return {
            formErrors: new Errors(),
            formComplete: false,
            submitting: false,
            generalError: false,

            email: '',
        };
    },

    mounted() {
        //
    },

    methods: {
        /**
         * Submit the form to the backend.
         *
         * @return {Void}
         */
        onFormSubmit(event) {
            // Set state
            this.submitting = true;

            const formData = {
                email: this.email,
            };

            // Submit form
            this.$api.gms.account.resetPassword(formData)
            .then(this.onSubmitSuccess)
            .catch(this.onSubmitError);
        },

        /**
         * Handles submission error(s).
         *
         * @return {Void}
         */
        onSubmitError(error) {
            this.submitting = false;

            this.formErrors.clear();
            zenscroll.toY(0);
            console.log(error);

            this.formErrors.record(error.data.result.errors);
        },

        /**
         * Handles submission success.
         *
         * @return {Void}
         */
        onSubmitSuccess(response) {
            this.submitting = false;
            if (!response.data.success) {
                console.log('General error');
                this.generalError = true;
                return;
            }

            this.formComplete = true;
            this.submitting = false;
        },
    },
});
